import { MAX_FILE_BYTES, MAX_IMAGE_BYTES } from './attachments.ts';

/** The size cap for one chat attachment of this type. */
export function maxChatAttachmentBytes(mimeType: string): number {
  return mimeType.startsWith('image/') ? MAX_IMAGE_BYTES : MAX_FILE_BYTES;
}
